  document.addEventListener("DOMContentLoaded", function () {
    // Data attribute se variants ka JSON parse karna
    let variants = JSON.parse(document.querySelector("[data-product-variants]").getAttribute("data-product-variants"));

    // Sab variants loop mein check karna
    variants.forEach(variant => {
      if (!variant.available) {
        // Jis element ka color match kare usko hide karna
        let variantElement = document.querySelector(`[data-color="${variant.color}"]`);
        if (variantElement) {
          variantElement.style.display = "none";
        }
      }
    });
  });